module.exports = __webpack_public_path__ + "assets/logo.ffe9256f.svg";